import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import { OutlinedInput, FormControl, FormHelperText } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
//
import "dayjs/locale/es-mx";
//
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import AutocompleteCom from "../../../Componentes/Kit/AutoComplete/AutocompleteCom";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
//

import { useAuth } from "../../Auth/AuthProtecter";

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(100% - ${theme.spacing(1)})`,
    // maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const PaymentContainer = styled("div")(({ theme }) => ({
  // display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%",
  height: "auto",
  padding: theme.spacing(2),
  borderRadius: `calc(${theme.shape.borderRadius}px + 4px)`,
  border: "1px solid ",
  borderColor: (theme.vars || theme).palette.divider,
  background:
    "linear-gradient(to bottom right, hsla(220, 35%, 97%, 0.3) 25%, hsla(220, 20%, 88%, 0.3) 100%)",
  boxShadow: "0px 4px 8px hsla(210, 0%, 0%, 0.05)",
  [theme.breakpoints.up("xs")]: {
    height: "auto",
    //height: 300,
  },
  [theme.breakpoints.up("sm")]: {
    // height: 350,
    height: "auto",
  },
  ...theme.applyStyles("dark", {
    background:
      "linear-gradient(to right bottom, hsla(220, 30%, 6%, 0.2) 25%, hsla(220, 20%, 25%, 0.2) 100%)",
    boxShadow: "0px 4px 8px hsl(220, 35%, 0%)",
  }),
}));

const FormGrid = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export default function AddressFormThree({ ...other }) {
  const auth = useAuth();
  const phone = auth.infoUserCheck().phone;
  //
  //
  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const dataperson = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); //
  //
  const optCodeArea = [
    {
      id: "0414",
      name: "414",
    },
    {
      id: "0424",
      name: "424",
    },
    {
      id: "0412",
      name: "412",
    },
    {
      id: "0416",
      name: "416",
    },
    {
      id: "0426",
      name: "426",
    },
  ];
  const sfalse = false;

  //Boton
  const [ActiveButtom, setActiveButtom] = React.useState(false);
  // code area
  const [codeArea, setCodeArea] = useState("");
  const [codeAreaError, setCodeAreaError] = useState(false);
  const [codeAreaErrorMessage, setcodeAreaErrorMessage] = useState("");
  const [codeAreaID, setcodeAreaID] = React.useState(null);

  // numero
  const [number, setnumber] = React.useState("");
  const [Number, setNumber] = React.useState("");
  const [numberError, setnumberError] = React.useState(false);
  const [numberErrorMessage, setnumberErrorMessage] = React.useState("");

  window.setTimeout(() => {
    if (phone === "~") {
      setnumber("~");
      setCodeArea("~");
    } else {
      const { areacode, number } = phone;
      setnumber(number);
      setCodeArea(areacode);
    }
  }, 1);

  const handleChange = (event) => {
    let inputValue = event.target.value.replace(/\D/g, ""); // Eliminar todo lo que no sea dígito

    if (inputValue.length > 6) {
      inputValue = inputValue.slice(0, 7); // Limitar a 6 dígitos
    }

    if (inputValue.length > 3) {
      inputValue = `${inputValue.slice(0, 3)}-${inputValue.slice(3)}`; // Formatear como 000-000
    }

    setNumber(inputValue);
  };

  const validateInputs = (e) => {
    let isValid = true;
    const nmr = /^\d+$/;

    const codeArea = document.getElementById("codeArea");
    const number = document.getElementById("number");

    // Validación para codeArea
    if (!codeArea.value || !nmr.test(codeArea.value)) {
      if (!codeArea.value) {
        setCodeAreaError(true);
        setcodeAreaErrorMessage("Vacío");
      } else {
        setCodeAreaError(true);
        setcodeAreaErrorMessage("Solo numérico");
      }
      isValid = false;
    } else {
      setCodeAreaError(false);
      setcodeAreaErrorMessage("");
    }

    // Validación para number
    if (!number.value) {
      setnumberError(true);
      setnumberErrorMessage("Vacío");
      isValid = false;
    } else {
      setnumberError(false);
      setnumberErrorMessage("");
    }

    if (isValid) {
      //
      const bytes = CryptoJS.AES.decrypt(
        sessionStorage.getItem(LST),
        secretKey
      );
      //
      const array = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      //

      const updatedValue = {
        ...array,
        areacode: codeArea.value,
        idpartyphone: phone.idpartyphone,
        number: number.value.replace(/[\s-]/g, ""),
      };

      console.log(updatedValue);

      sessionStorage.setItem(
        LST,
        CryptoJS.AES.encrypt(JSON.stringify(updatedValue), secretKey).toString()
      );

      other.SetActiButtom(isValid);
      setActiveButtom(true);
      ///
      ///
      ///
    } else {
      const dataPost = {
        codearea: codeArea.value,
        idpartyphone: phone.idpartyphone,
        number: number.value,
      };
      console.log("***********Error", dataPost);
    }
  };

  return (
    <Stack spacing={{ xs: 3, sm: 6 }} useFlexGap>
      <FormControl component="fieldset" fullWidth>
        <Card>
          <CardActionArea
            sx={{
              ".MuiCardActionArea-focusHighlight": {
                backgroundColor: "transparent",
              },
              "&:focus-visible": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AccountBoxIcon
                fontSize="large"
                sx={[
                  (theme) => ({
                    color: "grey.400",
                    ...theme.applyStyles("dark", {
                      color: "grey.600",
                    }),
                  }),
                ]}
              />
              <Typography sx={{ fontWeight: "medium" }}>
                <Typography sx={{ fontWeight: "medium" }}>
                  {dataperson.firstname} {dataperson.lastname}
                </Typography>{" "}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </FormControl>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Alert variant="filled" severity={"warning"}>
          <AlertTitle>
            {
              "Actualmente es posible  actualizar los datos faltantes en su registro. Para cambios y correcciones, recomendamos visitar la sucursal más cercana."
            }
          </AlertTitle>
        </Alert>
        <PaymentContainer>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="subtitle2">
              Agrega un numero de contacto
            </Typography>
            <ManageAccountsIcon sx={{ color: "text.secondary" }} />
          </Box>
          <ContactSupportIcon
            sx={{
              fontSize: { xs: 48, sm: 56 },
              color: "text.secondary",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            {codeArea === "~" ? (
              <FormGrid sx={{ maxWidth: "50%" }}>
                <AutocompleteCom
                  FormLabel={"Estado"}
                  error={codeAreaError}
                  errorMessage={codeAreaErrorMessage}
                  size="small"
                  placeholder={"414"}
                  id={"codeArea"}
                  autoComplete="codeArea"
                  options={optCodeArea}
                  setDataId={setcodeAreaID}
                  label={""}
                  required
                  disabled={ActiveButtom}
                />
              </FormGrid>
            ) : (
              <FormGrid sx={{ maxWidth: "30%" }}>
                <>
                  <FormLabel htmlFor="codeArea" required>
                    código
                  </FormLabel>
                  <OutlinedInput
                    id="codeArea"
                    autoComplete="codeArea"
                    value={codeArea}
                    required
                    size="small"
                    disabled={codeArea !== "~" ? true : false}
                  />
                </>
              </FormGrid>
            )}
            <FormGrid sx={{ flexGrow: 1 }}>
              <FormLabel htmlFor="number" required>
                Numero telefonico
              </FormLabel>
              <OutlinedInput
                error={numberError}
                id="number"
                autoComplete="number"
                placeholder="999 9999"
                required
                size="small"
                value={number !== "~" ? number : Number}
                onChange={handleChange}
                disabled={number !== "~" || ActiveButtom ? true : sfalse}
              />
              {numberError && (
                <FormHelperText>{numberErrorMessage}</FormHelperText>
              )}
            </FormGrid>
          </Box>
          <Button
            sx={{ mt: 5 }}
            disabled={ActiveButtom}
            fullWidth
            variant="contained"
            onClick={validateInputs}
          >
            Guardar
          </Button>
        </PaymentContainer>
      </Box>
    </Stack>
  );
}
